<template>
  <div class="template-connected">
    <div id="container">
      <div
        v-if="userConnected.roles.includes('ROLE_GUICHET') && userConnected.ticketOfficePerimeter != null"
        class="block-flat"
      >
        <div class="block-content">
          <fieldset>
            <legend>
              Demande en retard du guichet :
              {{ userConnected.ticketOfficePerimeter.libelle }}
            </legend>
          </fieldset>
          <b-table
            class="delay-table"
            v-if="dossiersDelayTicketOffice"
            :fields="fieldsTicketOffice"
            striped
            bordered
            hover
            :items="dossiersDelayTicketOffice"
          >
            <template #cell(id)="data">
              <div
                style="
                  position: absolute;
                  width: 100%;
                  height: 100%;
                  left: 0;
                  top: 0;
                "
                class="link-detail"
              >
                <div class="container-id">
                  <div class="id-text">
                    <b>{{ data.item.id }}</b>
                  </div>
                </div>
                <div class="hover-thumb" @click="goToDossier(data.item)">
                  <font-awesome-icon icon="eye"></font-awesome-icon>
                </div>
              </div>
            </template>
            <template #cell(cerfa1402301cerfa1402401)="data">
              <div class="text-center td-type">
                <span
                  v-if="
                    data.item.cerfa1402301 != null &&
                    data.item.cerfa1402401 == null
                  "
                >
                  <font-awesome-icon
                    :id="'tooltip-type-' + data.item.id"
                    icon="road"
                  ></font-awesome-icon>
                  <b-tooltip
                    :target="'tooltip-type-' + data.item.id"
                    triggers="hover"
                  >
                    Permission de voirie - cerfa n°14023*01
                  </b-tooltip>
                </span>
                <span
                  v-if="
                    data.item.cerfa1402401 != null &&
                    data.item.cerfa1402301 == null
                  "
                >
                  <font-awesome-icon
                    :id="'tooltip-type-' + data.item.id"
                    icon="car"
                  ></font-awesome-icon>
                  <b-tooltip
                    :target="'tooltip-type-' + data.item.id"
                    triggers="hover"
                  >
                    Arrêté de circulation - cerfa n°14024*01
                  </b-tooltip>
                </span>
                <span
                  v-if="
                    data.item.cerfa1402401 == null &&
                    data.item.cerfa1402301 == null
                  "
                >
                  <font-awesome-icon
                    :id="'tooltip-type-' + data.item.id"
                    icon="question-circle"
                  ></font-awesome-icon>
                  <b-tooltip
                    :target="'tooltip-type-' + data.item.id"
                    triggers="hover"
                  >
                    Pas de type
                  </b-tooltip>
                </span>
                <span
                  v-if="
                    data.item.cerfa1402401 != null &&
                    data.item.cerfa1402301 != null
                  "
                >
                  <font-awesome-icon
                    :id="'tooltip-type-' + data.item.id"
                    icon="road"
                  ></font-awesome-icon>
                  <font-awesome-icon
                    :id="'tooltip-type-' + data.item.id"
                    icon="car"
                  ></font-awesome-icon>
                  <b-tooltip
                    :target="'tooltip-type-' + data.item.id"
                    triggers="hover"
                  >
                    Permission de voirie et Arrêté de circulation
                  </b-tooltip>
                </span>
              </div>
            </template>
            <template #cell(address)="data">
              <div>
                <font-awesome-icon icon="map-marker-alt"></font-awesome-icon>
                {{ data.item.addressNum }} {{ data.item.addressExt }}
                {{ data.item.addressType }}
                {{ data.item.addressName }} {{ data.item.addressPostalCode }}
                {{ data.item.addressCity }}
              </div>
            </template>
            <template #cell(depositDate)="data">
              <div>
                <font-awesome-icon :icon="['far', 'clock']"></font-awesome-icon>
                {{ data.item.depositDate }}
              </div>
            </template>
            <template #cell(dateStart)="data">
              <div>
                <font-awesome-icon icon="wrench"></font-awesome-icon>
                {{ data.item.dateStart }}
              </div>
            </template>
          </b-table>
        </div>
      </div>

      <div
        v-if="userConnected.roles.includes('ROLE_GESTIONNAIRE') && userConnected.managerPerimeter != null"
        class="block-flat"
      >
        <div class="block-content">
          <fieldset>
            <legend>
              Demande en retard du gestionnaire de voirie :
              {{ userConnected.managerPerimeter.libelle }}
            </legend>
          </fieldset>
          <b-table
            class="delay-table"
            v-if="dossiersDelayManager"
            :fields="fieldsManager"
            striped
            bordered
            hover
            :items="dossiersDelayManager"
          >
            <template
              #cell(id)="data"
              style="
                position: absolute;
                width: 100%;
                height: 100%;
                left: 0;
                top: 0;
              "
            >
              <div class="text-center link-detail">
                <b>{{ data.item.id }}</b>
                <div class="hover-thumb" @click="goToDossier(data.item)">
                  <font-awesome-icon icon="eye"></font-awesome-icon>
                </div>
              </div>
            </template>
            <template #cell(cerfa1402301cerfa1402401)="data">
              <div class="text-center td-type">
                <span
                  v-if="
                    data.item.cerfa1402301 != null &&
                    data.item.cerfa1402401 == null
                  "
                >
                  <font-awesome-icon
                    :id="'tooltip-type-' + data.item.id"
                    icon="road"
                  ></font-awesome-icon>
                  <b-tooltip
                    :target="'tooltip-type-' + data.item.id"
                    triggers="hover"
                  >
                    Permission de voirie - cerfa n°14023*01
                  </b-tooltip>
                </span>
                <span
                  v-if="
                    data.item.cerfa1402401 != null &&
                    data.item.cerfa1402301 == null
                  "
                >
                  <font-awesome-icon
                    :id="'tooltip-type-' + data.item.id"
                    icon="car"
                  ></font-awesome-icon>
                  <b-tooltip
                    :target="'tooltip-type-' + data.item.id"
                    triggers="hover"
                  >
                    Arrêté de circulation - cerfa n°14024*01
                  </b-tooltip>
                </span>
                <span
                  v-if="
                    data.item.cerfa1402401 == null &&
                    data.item.cerfa1402301 == null
                  "
                >
                  <font-awesome-icon
                    :id="'tooltip-type-' + data.item.id"
                    icon="question-circle"
                  ></font-awesome-icon>
                  <b-tooltip
                    :target="'tooltip-type-' + data.item.id"
                    triggers="hover"
                  >
                    Pas de type
                  </b-tooltip>
                </span>
                <span
                  v-if="
                    data.item.cerfa1402401 != null &&
                    data.item.cerfa1402301 != null
                  "
                >
                  <font-awesome-icon
                    :id="'tooltip-type-' + data.item.id"
                    icon="road"
                  ></font-awesome-icon>
                  <font-awesome-icon
                    :id="'tooltip-type-' + data.item.id"
                    icon="car"
                  ></font-awesome-icon>
                  <b-tooltip
                    :target="'tooltip-type-' + data.item.id"
                    triggers="hover"
                  >
                    Permission de voirie et Arrêté de circulation
                  </b-tooltip>
                </span>
              </div>
            </template>
            <template #cell(address)="data">
              <div>
                <font-awesome-icon icon="map-marker-alt"></font-awesome-icon>
                {{ data.item.addressNum }} {{ data.item.addressExt }}
                {{ data.item.addressType }}
                {{ data.item.addressName }} {{ data.item.addressPostalCode }}
                {{ data.item.addressCity }}
              </div>
            </template>
            <template #cell(ticketOfficePerimeter)="data">
              <span v-if="data.item.ticketOfficePerimeter != null">{{
                data.item.ticketOfficePerimeter
                  .replace("Var,", "")
                  .replace(",Var", "")
              }}</span>
            </template>

            <template #cell(depositDate)="data">
              <div>
                <font-awesome-icon :icon="['far', 'clock']"></font-awesome-icon>
                {{ data.item.depositDate }}
              </div>
            </template>
            <template #cell(dateStart)="data">
              <div>
                <font-awesome-icon icon="wrench"></font-awesome-icon>
                {{ data.item.dateStart }}
              </div>
            </template>
          </b-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import router from "../router";
import Vuex from "vuex";
export default {
  data: () => ({
    fieldsTicketOffice: [
      {
        key: "id",
        sortable: true,
        label: "ID",
      },
      { key: "cerfa1402301cerfa1402401", label: "Type" },
      { key: "address", label: "Adresse" },
      {
        key: "depositDate",
        sortable: true,
        label: "Date de dépot",
      },
      {
        key: "dateStart",
        sortable: true,
        label: "Date de début",
      },
      {
        key: "operatorPerimeter",
        sortable: true,
        label: "Opérateur",
      },
      {
        key: "sousTraitantPerimeter",
        sortable: true,
        label: "Sous-traitant",
      },
    ],
    fieldsManager: [
      {
        key: "id",
        sortable: true,
        label: "ID",
      },
      { key: "cerfa1402301cerfa1402401", label: "Type" },
      { key: "address", label: "Adresse" },
      {
        key: "depositDate",
        sortable: true,
        label: "Date de dépot",
      },
      {
        key: "dateStart",
        sortable: true,
        label: "Date de début",
      },
      {
        key: "operatorPerimeter",
        sortable: true,
        label: "Opérateur",
      },
      {
        key: "sousTraitantPerimeter",
        sortable: true,
        label: "Sous-traitant",
      },
      {
        key: "ticketOfficePerimeter",
        sortable: true,
        label: "Guichet",
      },
    ],
  }),
  mounted() {
    this.getDossierDelaysTicketOffice();
    this.getDossierDelaysManager();
  },
  methods: {
    goToDossier(dossier) {
      // let encrypted = this.$aes.encrypt(dossier.id.toString());
      router.push({ name: "Dossier", params: { id: dossier.id } });
    },

    ...Vuex.mapActions("Dossiers", [
      "getDossierDelaysManager",
      "getDossierDelaysTicketOffice",
    ]),
  },
  computed: {
    ...Vuex.mapGetters("Dossiers", [
      "dossiersDelayManager",
      "dossiersDelayTicketOffice",
    ]),
    ...Vuex.mapGetters("Authentification", ["userConnected", "drawerStatus"]),
  },
};
</script>

<style></style>
